module.exports = __webpack_public_path__ + "static/10-e825986571f1c6a70cfde9859b94a5d5.png";